import { bindRequestLogic } from './utils'
import ScwPatentTypes from '../actionTypes/scwPatent'
import { scwPatentAPI } from '../api'

const getScwPatents = bindRequestLogic({
  clientFunc: scwPatentAPI.getScwPatents,
  type: ScwPatentTypes.GET_SCW_PATENTS_REQUEST,
  successType: ScwPatentTypes.GET_SCW_PATENTS_SUCCESS,
  failType: ScwPatentTypes.GET_SCW_PATENTS_FAILED,
  isQueryParam: true
})

const addScwPatent = bindRequestLogic({
  clientFunc: scwPatentAPI.addScwPatent,
  type: ScwPatentTypes.ADD_SCW_PATENT_REQUEST,
  successType: ScwPatentTypes.ADD_SCW_PATENT_SUCCESS,
  failType: ScwPatentTypes.ADD_SCW_PATENT_FAILED
})

const updateScwPatent = bindRequestLogic({
  clientFunc: scwPatentAPI.updateScwPatent,
  type: ScwPatentTypes.UPDATE_SCW_PATENT_REQUEST,
  successType: ScwPatentTypes.UPDATE_SCW_PATENT_SUCCESS,
  failType: ScwPatentTypes.UPDATE_SCW_PATENT_FAILED
})

const updateScwPatentStatus = bindRequestLogic({
  clientFunc: scwPatentAPI.updateScwPatentStatus,
  type: ScwPatentTypes.UPDATE_SCW_PATENT_STATUS_REQUEST,
  successType: ScwPatentTypes.UPDATE_SCW_PATENT_STATUS_SUCCESS,
  failType: ScwPatentTypes.UPDATE_SCW_PATENT_STATUS_FAILED
})

const getScwPatentDetail = bindRequestLogic({
  clientFunc: scwPatentAPI.getScwPatent,
  type: ScwPatentTypes.GET_SCW_PATENT_DETAIL_REQUEST,
  successType: ScwPatentTypes.GET_SCW_PATENT_DETAIL_SUCCESS,
  failType: ScwPatentTypes.GET_SCW_PATENT_DETAIL_FAILED
})

const deleteScwPatent = bindRequestLogic({
  clientFunc: scwPatentAPI.deleteScwPatent,
  type: ScwPatentTypes.DELETE_SCW_PATENT_REQUEST,
  successType: ScwPatentTypes.DELETE_SCW_PATENT_SUCCESS,
  failType: ScwPatentTypes.DELETE_SCW_PATENT_FAILED
})

const upsertContentTranslation = bindRequestLogic({
  clientFunc: scwPatentAPI.upsertScwPatentContent,
  type: ScwPatentTypes.UPSERT_SCW_PATENT_TRANSLATION_REQUEST,
  successType: ScwPatentTypes.UPSERT_SCW_PATENT_TRANSLATION_SUCCESS,
  failType: ScwPatentTypes.UPSERT_SCW_PATENT_TRANSLATION_FAILED
})

const getScwPatentContent = bindRequestLogic({
  clientFunc: scwPatentAPI.getScwPatentContent,
  type: ScwPatentTypes.GET_SCW_PATENT_CONTENT_REQUEST,
  successType: ScwPatentTypes.GET_SCW_PATENT_CONTENT_SUCCESS,
  failType: ScwPatentTypes.GET_SCW_PATENT_CONTENT_FAILED
})

export default [
  getScwPatents,
  addScwPatent,
  deleteScwPatent,
  updateScwPatent,
  updateScwPatentStatus,
  getScwPatentDetail,
  upsertContentTranslation,
  getScwPatentContent
]
